import React from 'react'

import {
  Row,
  Col,
  Radio,
  Tooltip,
  Tabs,
  Select,
  Input,
  Icon,
  Checkbox,
  Collapse
} from 'antd'

import { formatFileSize, formatNumber } from '../utils/functions'

const { TabPane } = Tabs
const { Panel } = Collapse
const { Option } = Select
const { TextArea } = Input

class Settings extends React.Component {
  constructor(props) {
    super(props)

  }

  isPhotoFile = (file) => {
    return file.destination.indexOf("images") > 0
  }


  renderOwnerOptions = users => {
    return this.props.data.users.map(u => {
      return (
        <Option key={u._id} value={u.username}>
          {u.lastName} {u.firstName}
        </Option>
      )
    })
  }

  renderGuestsOptions = users => {
    return this.props.data.users.map(u => {
      return (
        <Option key={u._id} value={u.username}>
          {u.lastName} {u.firstName} ({u.username})
        </Option>
      )
    })
  }

  render() {

    return (
      <Tabs onChange={() => {}} animated={false}>
          { ( this.props.authUser.isAdmin() || this.props.authUser.isSupervisor() || this.props.authUser.isGeneralUser() ) &&
            <TabPane tab="Folder" key="1">
                {(this.props.authUser.isAdmin() || this.props.authUser.isSupervisor()) ?
                    (<div>
                        <Collapse
                            defaultActiveKey={['1', '2', '3', '4']}
                            onChange={e => console.log(e)}
                        >
                            <Panel header="Security" key="1">
                                <Tooltip placement="topRight" title={'Save'}>
                                    <Icon
                                        type="save"
                                        style={{fontSize: '14px', float: 'right'}}
                                        onClick={this.props.handler.saveFolderSecurity}
                                    />
                                </Tooltip>
                                <div style={{clear: 'both'}}>
                                    <Row>
                                        <Col span={5}>
                                            <span>Owner:</span>
                                        </Col>
                                        <Col span={19}>
                                            <Select
                                                value={this.props.data.selectedOwner}
                                                style={{width: 240}}
                                                onChange={this.props.handler.onChangeOwner}
                                            >
                                                {this.renderOwnerOptions(this.props.users)}
                                            </Select>
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row>
                                        <Col span={5}>
                                            <span>Guests:</span>
                                        </Col>
                                        <Col span={19}>
                                            <Select
                                                value={this.props.data.selectedGuests}
                                                mode="multiple"
                                                style={{width: 300}}
                                                onChange={this.props.handler.onChangeGuests}
                                            >
                                                {this.renderGuestsOptions(this.props.data.users)}
                                            </Select>
                                        </Col>
                                    </Row>
                                </div>
                            </Panel>
                            {this.props.shareFolder ? (
                                <Panel header="Share link" key="2">
                                    <Tooltip placement="topRight" title={'Generate'}>
                                        <Icon
                                            type="link"
                                            style={{fontSize: '14px', float: 'right'}}
                                            onClick={this.props.handler.handleFolderGenerateLink}
                                        />
                                    </Tooltip>
                                    <TextArea rows={3} value={this.props.data.folderLink}/>
                                </Panel>
                            ) : null}

                            <Panel header="Styles" key="3">
                                <Tooltip placement="topRight" title={'Save'}>
                                    <Icon
                                        type="save"
                                        style={{fontSize: '14px', float: 'right'}}
                                        onClick={this.props.handler.saveStyles}
                                    />
                                </Tooltip>
                                <div style={{clear: 'both'}}>
                                    <Row>
                                        <Col span={5}>
                                            <span>Icon Color:</span>
                                        </Col>
                                        <Radio.Group
                                            value={this.props.data.iconColor}
                                            onChange={this.props.handler.onChangeIconColor}
                                        >
                                            <Radio.Button value="icon-folder-open-blue">
                                                Blue
                                            </Radio.Button>
                                            <Radio.Button value="icon-folder-open-green">
                                                Green
                                            </Radio.Button>
                                            <Radio.Button value="icon-folder-open-orange">
                                                Orange
                                            </Radio.Button>
                                            <Radio.Button value="icon-folder-open-red">
                                                Red
                                            </Radio.Button>
                                            <Radio.Button value="NoneSelected">None</Radio.Button>
                                        </Radio.Group>
                                    </Row>
                                    <br/>
                                    <Row>
                                        <Col span={5}>
                                            <span>Text Size:</span>
                                        </Col>
                                        <Radio.Group
                                            value={this.props.data.textSize}
                                            onChange={this.props.handler.onChangeTextSize}
                                        >
                                            <Radio.Button value="small">Small</Radio.Button>
                                            <Radio.Button value="medium">Medium</Radio.Button>
                                            <Radio.Button value="large">Large</Radio.Button>
                                        </Radio.Group>
                                    </Row>
                                    <br/>
                                    <Row>
                                        <Col span={5}>
                                            <span>Text Style:</span>
                                        </Col>
                                        <Checkbox.Group
                                            value={this.props.data.textStyle}
                                            options={[
                                                {label: 'Bold', value: 'bold'},
                                                {label: 'Italic', value: 'italic'},
                                            ]}
                                            onChange={this.props.handler.onChangeTextStyle}
                                        />
                                    </Row>
                                </div>
                            </Panel>

                            <Panel header="Comments" key="4">
                                <Tooltip placement="topRight" title={'Save'}>
                                    <Icon
                                        type="save"
                                        style={{fontSize: '14px', float: 'right'}}
                                        onClick={this.props.handler.saveFolderComments}
                                    />
                                </Tooltip>
                                <TextArea
                                    value={this.props.data.folderComments}
                                    rows={3}
                                    onChange={this.props.handler.onChangeFolderComments}
                                />
                            </Panel>
                        </Collapse>
                    </div>)
                : (this.props.authUser.isGeneralUser() && this.props.shareFolder) ? (
                        <div>
                            <Collapse
                                defaultActiveKey={['1', '2', '3', '4']}
                                onChange={e => console.log(e)}
                            >
                                <Panel header="Share link" key="2">
                                    <Tooltip placement="topRight" title={'Generate'}>
                                        <Icon
                                            type="link"
                                            style={{fontSize: '14px', float: 'right'}}
                                            onClick={this.props.handler.handleFolderGenerateLink}
                                        />
                                    </Tooltip>
                                    <TextArea rows={3} value={this.props.data.folderLink}/>
                                </Panel>
                            </Collapse>
                        </div>
                    ) : null}
            </TabPane>
          }
        <TabPane tab="File" key="2">
          <div>
            {this.props.data.file ? (
              <Collapse
                defaultActiveKey={['1', '2', '3']}
                onChange={e => console.log(e)}
              >
                <Panel header="Details" key="1">
                  <Row>
                    <Col span={6}>
                      <span>File name:</span>
                    </Col>
                    <Col span={18}>
                      <span>{this.props.data.file.originalname}</span>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <span>File size:</span>
                    </Col>
                    <Col span={18}>
                      <span>{formatFileSize(this.props.data.file.size)}</span>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <span>Uploaded by:</span>
                    </Col>
                    <Col span={18}>
                      <span>{this.props.data.file.uploadedBy}</span>
                    </Col>
                  </Row>
                    { this.isPhotoFile(this.props.data.file) &&
                       <Row>
                        <Col span={6}>
                          <span>Lat, Long :</span>
                        </Col>
                        <Col span={18}>
                          <span>
                            {formatNumber(this.props.data.file.lat) +
                              ', ' +
                              formatNumber(this.props.data.file.lng)}
                          </span>
                        </Col>
                      </Row>
                    }
                </Panel>
                {this.props.shareFile ? (
                  <Panel header="Share link" key="2">
                    <Tooltip placement="topRight" title={'Generate'}>
                      <Icon
                        type="link"
                        style={{ fontSize: '14px', float: 'right' }}
                        onClick={this.props.handler.handleFileGenerateLink}
                      />
                    </Tooltip>
                    <TextArea rows={3} value={this.props.data.fileLink} />
                  </Panel>
                ) : null}
                <Panel header="Comments" key="3">
                  <Tooltip placement="topRight" title={'Save'}>
                    <Icon
                      type="save"
                      style={{ fontSize: '14px', float: 'right' }}
                      onClick={this.props.handler.saveFileComments}
                    />
                  </Tooltip>
                  <TextArea
                    value={this.props.data.fileComments}
                    rows={3}
                    onChange={this.props.handler.onChangeFileComments}
                  />
                </Panel>
              </Collapse>
            ) : (
              <p>No file selected</p>
            )}
          </div>
        </TabPane>
      </Tabs>
    )
  }
}

export default Settings
